module.exports = __webpack_public_path__ + "img/IT-icon.98c3c209.png";